import { RegistrationWizardSkeleton } from "../../../layout/registration/RegistrationWizardSkeleton";
import { MaxWidthPageWithHeading } from "../../../layout/page/MaxWidthPageWithHeading";

export const PurchasePageSkeleton = () => (
    <MaxWidthPageWithHeading title="Purchase credits and add-ons">
        <RegistrationWizardSkeleton />
    </MaxWidthPageWithHeading>
);
